import { Fragment, useEffect } from "react"
import { useApi } from "../../../hooks/useApi"
import { Status } from "../../../hooks/useFetchState"
import React from "react"
import { Box, Paper } from "@mui/material"
import { GenericTable } from "../../../components/_EOS/Table/GenericTable"
import { inventoryCheckBlogTableHeaderConfig } from ".."
import { InventoryCheckBlog } from "../entities/InventoryCheck"
import { getInventoryCheckBlog } from "../api"


interface InventoryCheckBlogProps {
    inventoryCheckId: number
  }


export const InventoryCheckBlogComponent: React.FC<InventoryCheckBlogProps> = ({
    inventoryCheckId
  }) => {
    const { state, callApi } = useApi<InventoryCheckBlog[]>()
  
    
    const requestInventoryCheckBlogs = () => {
      callApi(getInventoryCheckBlog(inventoryCheckId))
    }
  
    useEffect(() => {
        requestInventoryCheckBlogs()
    }, [])
  
    return (
        <Fragment>
            <Box overflow={'auto'} maxHeight={'250px'} component={Paper}>
              <GenericTable<InventoryCheckBlog>
                headersConfig={inventoryCheckBlogTableHeaderConfig}
                data={state.data || []}
                IDKey={'inventoryCheckBlogId'}
                noResultsText='No existe información'
                isLoading={state.status === Status.Loading}
              />
            </Box>
        </Fragment>
    )
  }
  